// extracted by mini-css-extract-plugin
module.exports = {"adminName":"member-operations__AdminName__adminName"};